<template>
  <div class="top-contianer">
    <div class="video-container video-container-auv">
      <div class="mid-screen-text centered">
        <div class="who-we-are">
          Vortex In
          <a target="_blank" href="https://robosub.org/">Robosub</a>
        </div>
        <div class="what-we-do">Our Vision is a victory</div>
        <div style="text-align: center; width: 100%;">
          <b-button
            class="contact-us-home-button"
            pill
            variant="outline-secondary"
            href="#contact_us_auv"
          >Contact us 📞</b-button>
        </div>
        <div class="bounce">
          <a href="#appendix">
            <span class="down-arrow">&raquo;</span>
          </a>
        </div>
      </div>

      <video
        autoplay
        muted
        loop
        class="home-video"
        poster="../../public/img/auv/auv/auv_poster.png"
      >
        <source src="../../public/vid/assembly.mp4" type="video/mp4" />
      </video>
    </div>

    <GearsSep id="appendix" />
    <br />
    <div id="appendix-button" class="back-to-top-btn">
      <div v-b-tooltip.hover title="Back to Appendix" class="bounce">
        <a href="#appendix">
          <span>
            &nbsp&nbsp
            <span class="back-to-top-span">«</span>&nbsp&nbsp
          </span>
        </a>
      </div>
    </div>

    <div class="w-100 p-5">
      <div class="mini-nav-container">
        <h2 class="back-text">Shortcuts</h2>
        <h3 style="font-weight: bold;">Robosub Appendix</h3>
        <div class="breaker"></div>
        <b-button
          :href="navItem.href"
          v-for="navItem in navItems"
          :key="navItem.id"
          class="mini-nav-button"
          pill
          :target="navItem.target"
        >{{navItem.name}}</b-button>
      </div>
    </div>
    <br />
    <div id="team_info" class="eliptical-gray">
      <h2 class="back-text">Who are VORTEX?</h2>
      <h3 style="font-weight: bold;">Team</h3>
      <div class="breaker"></div>
      <br />
      <br />
      <div class="w-100">
        <b-img-lazy style="width: 80%; margin: auto;" src="../../public/img/auv/team/all.png"></b-img-lazy>
      </div>
      <div style="display: inline-block; width: 80%; margin-top: -15%;">
        <div class="what-we-do-cards" v-for="action in whatWeDo" :key="action.id">
          <b-img-lazy class="what-we-do-icon" :src="action.icon" :alt="action.name"></b-img-lazy>
          <div class="header">{{action.name}}</div>
          <div class="description">
            {{action.description}}
            <span v-if="action.redirect">
              <router-link target="_blank" to="/about_us">Click here&nbsp</router-link>to know our story in details.
            </span>
            <span v-if="action.redirect2">
              <router-link target="_blank" to="/commercial">&nbspVortex Commercial.</router-link>
            </span>
            <span v-if="action.redirect3">
              <router-link target="_blank" to="/swift-auv">Swift</router-link>
            </span>
          </div>
        </div>
        <div id="contact_us_auv">
          <h2 class="back-text">Get in touch</h2>
          <h3 style="font-weight: bold;">Contact us</h3>
          <div class="breaker"></div>
          <br />
          <br />
          <br />
          <b-container class="container_sb">
            <b-row class="this_row">
              <b-col class="justify_in_row">
                <div class="button facebook">
                  <i class="icon">
                    <i class="fa fa-facebook"></i>
                  </i>
                  <div class="slide">
                    <p>Our Page</p>
                  </div>
                  <a href="https://www.facebook.com/vortexroboticsegypt/">Vortex Robotics</a>
                  <div style="position:relative !important; left:-13%; top: -25% !important;">
                    <iframe
                      src="https://www.facebook.com/plugins/like.php?href=https%3A%2F%2Fwww.facebook.com%2Fvortexroboticsegypt%2F&width=62&layout=button&action=like&size=large&show_faces=false&share=false&height=65&appId=147915585232224"
                      width="62"
                      height="65"
                      style="border:none;overflow:hidden"
                      scrolling="no"
                      frameborder="0"
                      allowtransparency="true"
                    ></iframe>
                  </div>
                </div>
              </b-col>
              <b-col>
                <div class="linkedin button">
                  <i class="icon">
                    <i class="fa fa-linkedin"></i>
                  </i>
                  <div class="slide">
                    <p>Connect</p>
                  </div>
                  <div style="position:relative !important; top: 20% !important;">
                    <a href="https://www.linkedin.com/company/35717487">Vortex Robotics</a>
                  </div>
                </div>
              </b-col>
              <b-col>
                <div class="google button">
                  <i class="icon">
                    <i class="fa">&#xf095;</i>
                  </i>
                  <div class="slide">
                    <p>Call us</p>
                  </div>
                  <a
                    style="position:relative; top: 20%;"
                    href="tel:+201116997475"
                  >+20&nbsp; 3&nbsp; 5230010</a>
                </div>
              </b-col>
              <b-col>
                <div class="gmail button">
                  <i class="icon">
                    <i class="fa fa-google"></i>
                  </i>
                  <div class="slide">
                    <p>Email Us Now!</p>
                  </div>
                  <div style="position:relative !important; top: 20% !important;">
                    <a href="mailto:info@vortex-co.com">info@vortex-co.com</a>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-container>
        </div>
        <br />
      </div>
    </div>
    <br />
    <div class="w-100">
      <a target="_blank" href="/swift-auv">
        <b-img-lazy
          id="moving-auv"
          class="moving-auv-img"
          src="../../public/img/auv/auv/side_auv.png"
        ></b-img-lazy>
      </a>
    </div>
    <br />
    <div id="members" class="eliptical-gray">
      <h2 class="back-text">Our Heros</h2>
      <h3 style="font-weight: bold;">Participating Members</h3>
      <div class="breaker"></div>
      <br />
      <div class="auv-heads-cards" v-for="leader in auvLeaders" :key="leader.id">
        <b-card class="team-member-card mb-2" style="width: 300px;" rounded="circle" rounded-circle>
          <b-card-body>
            <div class="image-container">
              <div class="image-container-overlay"></div>

              <b-card-img-lazy
                :src="leader.img"
                class="card-img-top"
                img-alt="Image"
                img-top
                rounded="circle"
              ></b-card-img-lazy>
            </div>

            <b-card-title class="mt-3 fc-p fw-n">{{leader.name}}</b-card-title>
            <hr style="width: 60%;" />
            <b-card-text style="margin-top: -4%; font-weight: bold; ">{{leader.position}}</b-card-text>
            <a v-if="leader.linkedin !== ''" target="_blank" :href="leader.linkedin">
              <i class="fa fa-linkedin" style="font-size:22px;"></i>
            </a>
            <a v-if="leader.linkedin === ''">
              <i class="fa fa-linkedin" style="font-size:22px; color:gray;"></i>
            </a>
          </b-card-body>
        </b-card>
      </div>
      <hr style="width: 50%;" />
      <div style="display: inline-block; width: 100%;">
        <div class="auv-heads-cards" v-for="head in auvHeads" :key="head.id">
          <div>
            <b-card class="team-member-card mb-2" rounded="circle" rounded-circle>
              <b-card-body>
                <div class="image-container">
                  <div class="image-container-overlay"></div>

                  <b-card-img-lazy
                    :src="head.img"
                    class="card-img-top"
                    img-alt="Image"
                    img-top
                    rounded="circle"
                  ></b-card-img-lazy>
                </div>

                <b-card-title
                  style="font-weight: bold !important;"
                  class="mt-3 fc-p fw-n"
                >{{head.name}}</b-card-title>
                <hr style="width: 60%;" />

                <b-card-text style="font-weight: bold; margin-top: -4%;">{{head.position}}</b-card-text>
                <a v-if="head.linkedin !== ''" target="_blank" :href="head.linkedin">
                  <i class="fa fa-linkedin" style="font-size:22px;"></i>
                </a>
                &nbsp
                <i
                  v-if="head.resume && head.resume !== ''"
                  class="fa fa-circle"
                  aria-hidden="true"
                  style="font-size:5px; color:black;"
                ></i>

                <a v-if="head.resume && head.resume !== ''" target="_blank" :href="head.resume">
                  <i
                    v-b-tooltip.hover
                    title="View Resume"
                    class="fa fa-file-pdf-o"
                    style="margin-left: 8px;font-size:24px; color: maroon;"
                  ></i>
                </a>
              </b-card-body>
            </b-card>
          </div>
        </div>
      </div>
      <hr style="width: 50%;" />
      <h4 class="back-text">THE GEEKS</h4>
      <h4 style="font-weight: bold;">Software Members 👨‍💻</h4>
      <div class="breaker"></div>
      <div class="inline-horizontal-scroll">
        <div class="auv-members-cards" v-for="member in softwareMembers" :key="member.id">
          <div>
            <b-card class="team-member-card mb-2" rounded="circle" rounded-circle>
              <b-card-body>
                <div class="image-container">
                  <div class="image-container-overlay"></div>

                  <b-card-img-lazy
                    :src="member.img"
                    class="card-img-top"
                    img-alt="Image"
                    img-top
                    rounded="circle"
                  ></b-card-img-lazy>
                </div>

                <b-card-title
                  style="font-weight: bold !important;"
                  class="mt-3 fc-p fw-n"
                >{{member.name}}</b-card-title>
                <hr style="width: 60%;" />

                <a v-if="member.linkedin !== ''" target="_blank" :href="member.linkedin">
                  <i class="fa fa-linkedin" style="font-size:22px;"></i>
                </a>
                <a v-if="member.linkedin === ''">
                  <i class="fa fa-linkedin" style="font-size:22px; color:gray;"></i>
                </a>&nbsp
                <i
                  v-if="member.resume && member.resume !== ''"
                  class="fa fa-circle"
                  aria-hidden="true"
                  style="font-size:5px; color:black;"
                ></i>

                <a
                  v-if="member.resume && member.resume !== ''"
                  target="_blank"
                  :href="member.resume"
                >
                  <i
                    v-b-tooltip.hover
                    title="View Resume"
                    class="fa fa-file-pdf-o"
                    style="margin-left: 8px;font-size:24px; color: maroon;"
                  ></i>
                </a>
              </b-card-body>
            </b-card>
          </div>
        </div>
      </div>
      <hr style="width: 50%;" />
      <h4 id="the-gears" class="back-text">THE GEARS</h4>
      <h4 style="font-weight: bold;">Mechanical Members ⚙️</h4>
      <div class="breaker"></div>
      <div class="inline-horizontal-scroll">
        <div class="auv-members-cards" v-for="member in mechanicalMembers" :key="member.id">
          <div>
            <b-card class="team-member-card mb-2" rounded="circle" rounded-circle>
              <b-card-body>
                <div class="image-container">
                  <div class="image-container-overlay"></div>
                  <b-card-img-lazy
                    :src="member.img"
                    class="card-img-top"
                    img-alt="Image"
                    img-top
                    rounded="circle"
                  ></b-card-img-lazy>
                </div>

                <b-card-title
                  style="font-weight: bold !important;"
                  class="mt-3 fc-p fw-n"
                >{{member.name}}</b-card-title>

                <hr style="width: 60%;" />
                <a v-if="member.linkedin !== ''" target="_blank" :href="member.linkedin">
                  <i class="fa fa-linkedin" style="font-size:22px;"></i>
                </a>
                <a v-if="member.linkedin === ''">
                  <i class="fa fa-linkedin" style="font-size:22px; color:gray;"></i>
                </a>&nbsp
                <i
                  v-if="member.resume && member.resume !== ''"
                  class="fa fa-circle"
                  aria-hidden="true"
                  style="font-size:5px; color:black;"
                ></i>
                <a
                  v-if="member.resume && member.resume !== ''"
                  target="_blank"
                  :href="member.resume"
                >
                  <i
                    v-b-tooltip.hover
                    title="View Resume"
                    class="fa fa-file-pdf-o"
                    style="margin-left: 8px;font-size:24px; color: maroon;"
                  ></i>
                </a>
              </b-card-body>
            </b-card>
          </div>
        </div>
      </div>
      <hr style="width: 50%;" />
      <h4 class="back-text">THE POWER</h4>
      <h4 style="font-weight: bold;">Electric Members ⚡</h4>
      <div class="breaker"></div>
      <div class="inline-horizontal-scroll">
        <div class="auv-members-cards" v-for="member in electricalMembers" :key="member.id">
          <div>
            <b-card class="team-member-card mb-2" rounded="circle" rounded-circle>
              <b-card-body>
                <div class="image-container">
                  <div class="image-container-overlay"></div>

                  <b-card-img-lazy
                    :src="member.img"
                    class="card-img-top"
                    img-alt="Image"
                    img-top
                    rounded="circle"
                  ></b-card-img-lazy>
                </div>

                <b-card-title
                  style="font-weight: bold !important;"
                  class="mt-3 fc-p fw-n"
                >{{member.name}}</b-card-title>
                <hr style="width: 60%;" />

                <a v-if="member.linkedin !== ''" target="_blank" :href="member.linkedin">
                  <i class="fa fa-linkedin" style="font-size:22px;"></i>
                </a>

                <a v-if="member.linkedin === ''">
                  <i class="fa fa-linkedin" style="font-size:22px; color:gray;"></i>
                </a>&nbsp
                <i
                  v-if="member.resume && member.resume !== ''"
                  class="fa fa-circle"
                  aria-hidden="true"
                  style="font-size:5px; color:black;"
                ></i>
                <a
                  v-if="member.resume && member.resume !== ''"
                  target="_blank"
                  :href="member.resume"
                >
                  <i
                    v-b-tooltip.hover
                    title="View Resume"
                    class="fa fa-file-pdf-o"
                    style="margin-left: 8px;font-size:24px; color: maroon;"
                  ></i>
                </a>
              </b-card-body>
            </b-card>
          </div>
        </div>
        <br />
        <br />
        <br />
        <br />
      </div>
    </div>
    <br />
    <div class="w-100">
      <a target="_blank" href="/swift-auv">
        <b-img-lazy
          id="moving-auv-2"
          class="moving-auv-img-2"
          src="../../public/img/auv/auv/side_auv_2.png"
        ></b-img-lazy>
      </a>
    </div>

    <br />
    <br />
    <div id="news" class="main eliptical-gray">
      <div id="auv-moments" class="main-topics-container">
        <div class="myBtnContainer" id="myBtnContainer">
          <h4 class="back-text">GALLERY</h4>
          <h3 style="font-weight: bold;">Memorable Moments 📷</h3>
          <div class="breaker" style="margin-bottom: 60px;"></div>
          <b-container>
            <b-row>
              <b-col sm="11">
                <b-button
                  v-for="category in newsCategories"
                  :key="category.id"
                  :class="'btn ' + category.active"
                  @click="filterSelection(category.name)"
                >{{category.name}}</b-button>
              </b-col>
            </b-row>
          </b-container>
        </div>

        <div class="row">
          <div v-for="topic in mainTopics" :key="topic.id" :class="'newsColumn ' + topic.category">
            <div class="newsContent">
              <div class="newsImageContainer">
                <b-img-lazy
                  :src="topic.picture"
                  v-b-modal=" 'picture' + topic.id"
                  class="newsImage"
                  alt="News Image"
                  style="width:100%"
                ></b-img-lazy>
              </div>
              <h4 class="mt-4">{{topic.title}}</h4>
              <h5 class="date">{{topic.date}}</h5>
              <hr />
              <p>{{topic.description}}</p>

              <b-modal :id=" 'picture' + topic.id" size="lg" ok-only :title="topic.title">
                <b-img-lazy style="width: 100%;" :src="topic.picture"></b-img-lazy>
              </b-modal>
            </div>
          </div>
        </div>

        <b-alert :show="noNews" variant="danger">Whoops! Nothing here.. try changing the filter.</b-alert>
        <br />
      </div>
    </div>
    <div style="width: 100%; height: 150px;"></div>

    <div class="eliptical-gray" id="quality">
      <h4 class="back-text">What Makes Us Different</h4>
      <h3 style="font-weight: bold;">Quality</h3>
      <div class="breaker" style="margin-bottom: 60px;"></div>
      <div class="row" style="justify-content: center;">
        <div class="col md quality-container-col" v-for="itemQ in quality" :key="itemQ.id">
          <b-carousel controls indicators :interval="2000" class="row w-100" style=" margin: auto ">
            <b-carousel-slide
              style="height: 250px; width: 100%;"
              v-for="img in itemQ.images"
              :key="img.id"
              :img-src="img.src"
              :img-alt="img.name"
              v-b-modal=" 'picture' + itemQ.id + '_' + img.id"
              :caption="img.name"
              :caption-tag="'h5'"
            >
              <b-modal
                :id=" 'picture' + itemQ.id + '_' + img.id"
                size="lg"
                ok-only
                :title="img.name"
              >
                <b-img-lazy class="w-100" :src="img.src"></b-img-lazy>
              </b-modal>
            </b-carousel-slide>
          </b-carousel>
          <div class="row">
            <h3 style="width: 80%; margin: auto; color: #00264a">{{itemQ.name}}</h3>
          </div>
          <hr style="width:70%; margin: auto;" />
          <div class="row">
            <h5 style="width: 80%; margin: auto;">{{itemQ.text}}</h5>
          </div>
          <br />
        </div>
      </div>
    </div>
    <div id="sponsors" style="text-align: center; width: 100%; color: #00264a;">
      <h2 class="back-text">Wall Of Fame</h2>
      <h3 style="font-weight: bold;">Partners & Sponsors</h3>
      <div class="breaker"></div>
      <br />
      <div style="display: inline-block; width: 84.22%;">
        <h4
          style="opacity: 0.8;"
        >Vortex would like to express gratitude to everyone who has supported us along SWIFT’s journey. Without their assistance, Vortex would not have been able to compete in Robosub 2021.</h4>
        <div class="sponsor-logo" v-for="sponsor in sponsors" :key="sponsor.id">
          <b-img-lazy class="sponsor-logo-img" :src="sponsor.logo"></b-img-lazy>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GearsSep from "./../components/GearsSep.vue";

export default {
  components: {
    GearsSep
  },
  data() {
    return {
      firstTime: true,
      firstTime2: true,
      auvPosition: 0,
      onVideoLoad: false,

      noNews: true,
      j: 0,
      slide: 0,
      sliding: null,
      quality: [
        {
          id: 0,
          name: "Enclosures Labeling",
          text:
            "We labeled each enclosure by craving it's name on its cover to make it easier while installing them",
          images: [
            {
              id: 0,
              src: "img/auv/quality/enclosure_name1.jpg",
              name: "Control Enclosure Label"
            },
            {
              id: 1,
              src: "img/auv/quality/enclosure_name2.jpg",
              name: "battery Enclosure Label"
            },
            {
              id: 2,
              src: "img/auv/quality/enclosure_name3.jpg",
              name: "Propulsion Enclosure Label"
            }
          ]
        },
        {
          id: 1,
          name: "Wiring holes Labeling",
          text:
            "We labeled each hole in each container by a number and created a wiring table to illustrate how these holes will be connected together and make it easier while connecting",
          images: [
            {
              id: 0,
              src: "img/auv/quality/wiring_holes1.jpg",
              name: "Wiring holes numbering example"
            },
            {
              id: 1,
              src: "img/auv/quality/wiring_holes2.jpg",
              name: "Wiring holes numbering example"
            },
            {
              id: 2,
              src: "img/auv/quality/wiring_holes3.jpg",
              name: "Wiring holes numbering example"
            },
            {
              id: 3,
              src: "img/auv/quality/wiring_table.png",
              name: "Wiring table small example"
            }
          ]
        },
        {
          id: 2,
          name: "Factory Manufactured PCBs",
          text:
            "We picked laser routing in manufacturing all our PCBs to make sure its quality is as high as possible.",
          images: [
            {
              id: 0,
              src: "img/auv/quality/pcb1.jpg",
              name: "Manufactured PCBs"
            },
            { id: 1, src: "img/auv/quality/pcb2.jpg", name: "Propulsion PCB" },
            {
              id: 2,
              src: "img/auv/quality/pcb3.jpg",
              name: "Propulsion PCB with ESCs"
            },
            { id: 3, src: "img/auv/quality/pcb4.jpg", name: "BMS PCB" }
          ]
        },
        {
          id: 3,
          name: "Agile Software Development",
          text:
            "Internally as a team, we sticked to the agile principles of development with Bi-Weekly sprints each having its planning, retro, standups and status meetings. (Online)",
          images: [
            {
              id: 0,
              src: "img/auv/quality/meeting.png",
              name: "Online Weekly Meeting"
            }
          ]
        },
        {
          id: 4,
          name: "Product-like Software Documenting",
          text:
            "Internally as a software team, we dealed with the AUV as a product so, we documented each phase in a professional way using Full System Architectures, Sub-Module Diagrams, Sequence Diagrams, Module Requirements specifications, UML Class diagrams and Full requirements document.",
          images: [
            {
              id: 0,
              src: "img/auv/quality/architecture.png",
              name: "System Architecture"
            },
            {
              id: 1,
              src: "img/auv/quality/module.png",
              name: "Sub Module Diagram example"
            },
            {
              id: 2,
              src: "img/auv/quality/sequence.png",
              name: "Sub Module Sequence diagram example"
            },
            {
              id: 3,
              src: "img/auv/quality/requirements.png",
              name: "Sub Module Requirements example"
            },
            {
              id: 4,
              src: "img/auv/quality/uml.png",
              name: "Sub Module Classes UML example"
            }
          ]
        }
      ],
      navItems: [
        {
          id: 0,
          name: "Team",
          href: "#team_info"
        },
        {
          id: 1,
          name: "Members",
          href: "#members"
        },
        {
          id: 2,
          name: "Swift AUV",
          href: "/swift-auv",
          target: "_blank"
        },
        {
          id: 3,
          name: "Moments",
          href: "#news"
        },
        {
          id: 4,
          name: "Quality",
          href: "#quality"
        },
        {
          id: 5,
          name: "Sponsors",
          href: "#sponsors"
        }
      ],
      auvLeaders: [
        {
          id: 0,
          name: "Amr Essam",
          position: "Team Captain",
          img: "img/team/amr.jpg",
          linkedin: "https://www.linkedin.com/in/amr-khamis/"
        },
        {
          id: 1,
          name: "Abdelrahman Elmaradny",
          position: "Technical Advisor",
          img: "img/team/maradny1.jpg",
          linkedin: ""
        }
      ],
      auvHeads: [
        {
          id: 1,
          name: "Islam Gamal",
          position: "Head Software",
          img: "img/auv/team/software/islam_gamal.png",
          linkedin: "https://www.linkedin.com/in/islamgamaal",
          resume:
            "https://drive.google.com/file/d/1mh9QVun0H_nJzzNOBazJ5pIRa0_9m83G/view?usp=sharing"
        },
        {
          id: 2,
          name: "Mahmoud Assem",
          position: "Head Electrical",
          img: "img/team/mahmoud_assem.jpg",
          linkedin: "https://www.linkedin.com/in/mahmoud-eid-a31433147"
        },
        {
          id: 3,
          name: "Lina Nassar",
          position: "Head Mechanical",
          img: "img/team/lina.jpg",
          linkedin: "https://www.linkedin.com/in/lina-nassar-37664517b"
        }
      ],
      softwareMembers: [
        {
          id: 0,
          name: "Ahmed Ayman",
          position: "Vision Lead",
          img: "img/auv/team/software/ahmed_ayman.jpg",
          linkedin: "https://www.linkedin.com/in/ahmed-abouelnour/",
          resume:
            "https://drive.google.com/file/d/1iitxMAvUbl5aJHpp1jiIgQ-njGH0MpCY/view?usp=sharing"
        },
        {
          id: 1,
          name: "Omar Ahmed",
          position: "Control Lead",
          img: "img/auv/team/software/omar.jpg",
          linkedin:
            "https://www.linkedin.com/in/omar-ahmed-abdul-aziz-a8100719a/",
          resume:
            "https://drive.google.com/file/d/1oRD_aY9T6oaP-1_pXKRVPe-C2IfXaRI6/view?usp=sharing"
        },
        {
          id: 2,
          name: "Zeyad Ahmed",
          position: "Sensor Fusion Lead",
          img: "img/auv/team/software/zeyad.png",
          linkedin: "https://www.linkedin.com/in/zeiad-ahmed-b09576213"
        },
        {
          id: 3,
          name: "Mohamed Magdy",
          position: "Hardware Lead",
          img: "img/auv/team/software/magdy.JPG",
          linkedin: ""
        },
        {
          id: 4,
          name: "Islam Wael",
          position: "",
          img: "img/auv/team/software/islam.png",
          linkedin: "",
          resume:
            "https://drive.google.com/file/d/1eoDnQCNHeOD3dO9trZ0wDd_9Q6ScZkPo/view?usp=sharing"
        },
        {
          id: 5,
          name: "Mohamed Salem",
          position: "",
          img: "img/auv/team/software/salem.jpg",
          linkedin: "https://www.linkedin.com/in/muhammad-salem-532725213/",
          resume:
            "https://drive.google.com/file/d/1U8GmOsEuVjSyGEXv3om3MK8gWdtGbqs-/view?usp=sharing"
        },
        {
          id: 6,
          name: "Abdelaziz Assem",
          position: "",
          img: "img/auv/team/software/abdelaziz.jpg",
          linkedin: "",
          resume:
            "https://drive.google.com/open?id=1VmLcoQSN2ozQte4R_VXM4mR30YvhD0GU"
        },
        {
          id: 7,
          name: "Mariam Mahmoud",
          position: "",
          img: "img/auv/team/software/mariam.png",
          linkedin: "https://www.linkedin.com/in/maryem-mahmoud-425717176",
          resume:
            "https://drive.google.com/open?id=1ThXagZn9IR_waqsIphifx0NCOdEtU-cW"
        },
        {
          id: 8,
          name: "Fatma Mohamed",
          position: "",
          img: "img/auv/team/software/fatma.jpg",
          linkedin: "https://www.linkedin.com/in/fatma-mohamed-58b647154/",
          resume:
            "https://drive.google.com/file/d/18456yR_tqU0FMBBNHcrT-JDvEeWxVj4P/view?usp=sharing"
        },
        {
          id: 9,
          name: "Gad Mohamed",
          position: "",
          img: "img/auv/team/software/gad.png",
          linkedin: "https://www.linkedin.com/in/gadm/",
          resume:
            "https://drive.google.com/file/d/1tdr6Q_7GvhbPhm1kVGtMoQcWKnH3eJxs/view?usp=sharing"
        },
        {
          id: 10,
          name: "Mohannad Kandil",
          position: "",
          img: "img/auv/team/software/mohanad.jpg",
          linkedin: "https://www.linkedin.com/in/mohanad-kandil-aa7814111/",
          resume:
            "https://drive.google.com/file/d/1NZW3p26Y7xgMKUQrJIXGjZDfTURJe4nt/view?usp=sharing"
        },
        {
          id: 12,
          name: "Abdalla Ibrahim",
          position: "",
          img: "img/auv/team/software/mhmd.jpeg",
          linkedin: "https://www.linkedin.com/in/abdallah-ibrahim-9b77671ba",
          resume:
            "https://drive.google.com/file/d/1HCMDXgTdn9cDHMQzAMvlOEk9r4_RXypk/view?usp=sharing"
        },
        {
          id: 13,
          name: "Eyad Ahmed",
          position: "",
          img: "img/auv/team/software/eyad.png",
          linkedin: "https://www.linkedin.com/in/eyad-ahmed-74b3b31a1/",
          resume:
            "https://drive.google.com/file/d/1QTrNf8BgHeWC3WuIeERct94789VC8O-X/view?usp=sharing"
        },
        {
          id: 14,
          name: "Anas Khamees",
          position: "",
          img: "img/auv/team/software/Anas.jpg",
          linkedin: "",
          resume:
            "https://drive.google.com/file/d/1f_IJfQzSCGrNXpUZZ_5swHQoRF-aJNrL/view?usp=sharing"
        },
        // {
        //   id: 15,
        //   name: "Ahmed El-Ramady",
        //   position: "",
        //   img: "img/auv/team/software/ramady.jpeg",
        //   linkedin: ""
        // },
        // {
        //   id: 16,
        //   name: "Ziad Yasser",
        //   position: "",
        //   img: "img/auv/team/software/ziad.jpeg",
        //   linkedin: "https://www.linkedin.com/in/ziadyasser/",
        //   resume:
        //     "https://drive.google.com/file/d/1_1GrjMuFPmTNfBSdB5F1aktueu9WCmw0/view?usp=sharing"
        // },
        {
          id: 17,
          name: "Rania Sami",
          position: "",
          img: "img/auv/team/software/rania.jpg",
          linkedin: "http://www.linkedin.com/in/rania-elbaz",
          resume:
            "https://drive.google.com/file/d/1w_Z0AgkRbNIjRIk39KHeEOqqzo_fv9JM/view?usp=sharing"
        },
        {
          id: 18,
          name: "Shororuk Talaat",
          position: "",
          img: "img/auv/team/noprofile.png",
          linkedin: ""
        }
      ],
      mechanicalMembers: [
        {
          id: 2,
          name: "Heba hesham",
          img: "img/auv/team/mechanical/heba.png",
          resume:
            "https://drive.google.com/file/d/1SK-RmGN6PTUq7GySgtPRVHGtlcmSAXvY/view?usp=sharing",
          linkedin: "https://www.linkedin.com/in/heba-el-ghamrawy-a7b238143"
        },

        {
          id: 8,
          name: "Mahmoud Nawar",
          img: "img/auv/team/mechanical/mahmoud_nawaar.jpg",
          resume:
            "https://drive.google.com/file/d/1eg0xBK9yA73rcWbLfLeMG-ihAzwB4f38/view?usp=sharing",
          linkedin: "https://www.linkedin.com/in/mahmoudnawar309/"
        },
        {
          id: 1,
          name: "Nawaar Nasrat",
          img: "img/auv/team/mechanical/nawaar.png",
          resume: "https://gofile.io/d/DckCGl",
          linkedin: ""
        },
        {
          id: 3,
          name: "Mohanned shahen",
          position: "H. Software",
          img: "img/auv/team/noprofile.png",
          linkedin: ""
        },
        {
          id: 4,
          name: "Ahmed Tarek",
          position: "H. Software",
          img: "img/auv/team/noprofile.png",
          linkedin: "",
          resume:
            "https://drive.google.com/file/d/1OctJUFoyUqE2bu42NQRt1QPC0Dib8FMX/view?usp=sharing"
        },
        {
          id: 5,
          name: "Abdullah Hosny",
          position: "H. Software",
          img: "img/auv/team/noprofile.png",
          linkedin: ""
        },
        {
          id: 6,
          name: "Ahmed Bahaa",
          position: "H. Software",
          img: "img/auv/team/noprofile.png",
          linkedin: "https://www.linkedin.com/in/ahmed-bahaa-762a561b2"
        },
        {
          id: 7,
          name: "Hossam Ibrahem",
          img: "img/auv/team/noprofile.png",
          resume:
            "https://drive.google.com/drive/folders/1FmOp6DsMLT7Sb7PENqR7TVPtn8YH6qYZ?usp=sharing",
          linkedin: ""
        }
      ],
      electricalMembers: [
        {
          id: 1,
          name: "Rafael Zaher",
          position: "",
          img: "img/auv/team/electrical/rafael.jpg",
          linkedin: ""
        },
        {
          id: 2,
          name: "Ahmed Solyman",
          position: "",
          img: "img/auv/team/electrical/solyman.JPG",
          linkedin: "https://www.linkedin.com/in/ahmedsouly2nd/",
          resume:
            "https://drive.google.com/file/d/126zpSldraHY2zZ-fxEHTB6NjMOCtppOk/view?usp=sharing"
        }
      ],
      whatWeDo: [
        {
          id: 0,
          icon: "img/auv/about/pyramids.png",
          name: "Our beginning",
          redirect: true,
          description:
            "Vortex Robotics is an Egyptian team, established in 2018, was the first manufacturer of ROV in the Middle East, "
        },
        {
          id: 1,
          icon: "img/rovs/vdrax/vdrax_3d.png",
          name: "Vortex in Commercial",
          redirect2: true,
          description:
            "Vortex own it's commercial ROV (V-DRAX) and offer many offshore services. You should take a look here: "
        },
        {
          id: 2,
          icon: "img/icons/what_we_do/auv.png",
          name: "What we decided",
          redirect3: true,
          description:
            "With the help of the experience in the underwater world, the team decided to compete in Robosub 2021 for the first time with "
        },
        {
          id: 3,
          icon: "img/auv/about/gathering.png",
          name: "Gathering",
          description:
            "Vortex gathered a team from the most experienced graduates & undergraduates from allover Egypt to build a strong structured team."
        },
        {
          id: 4,
          icon: "img/auv/about/hierarchy.png",
          name: "Team Structure",
          description:
            "Our team is divided into 3 subteams; Mechanical team, Electrical team and Software team each contribute in it's own part building the AUV."
        }
      ],
      newsCategories: [
        { id: 0, name: "All" },
        { id: 1, name: "Software 👨‍💻" },
        { id: 2, name: "Electrical ⚡" },
        { id: 3, name: "Mechanical ⚙️" },
        { id: 4, name: "Out Reach 📣" },
        { id: 5, name: "Fun 🎉" }
      ],
      sponsors: [
        {
          id: 0,
          name: "SeaSplit",
          logo: "img/logos/sponsors/sea-split.jpeg"
        },
        {
          id: 1,
          name: "Arab Academy For Science and Technology",
          logo: "img/logos/sponsors/aast.jpeg"
        },
        {
          id: 2,
          name: "Mathworks",
          logo: "img/auv/sponsors/mathworks.png"
        },
        {
          id: 3,
          name: "Nvidia",
          logo: "img/auv/sponsors/nvidia.png"
        },
        {
          id: 4,
          name: "Blue Robotics",
          logo: "img/logos/sponsors/blue-robotics.png"
        },
        {
          id: 5,
          name: "Solidworks",
          logo: "img/auv/sponsors/solidworks.png"
        },
        {
          id: 6,
          name: "Waterlinked",
          logo: "img/auv/sponsors/water_linked.png"
        },
        {
          id: 7,
          name: "Bluetrial",
          logo: "img/auv/sponsors/blue_trail.png"
        },
        {
          id: 8,
          name: "Aquarian",
          logo: "img/auv/sponsors/aquarian.png"
        },
        {
          id: 9,
          name: "Autodesk",
          logo: "img/auv/sponsors/autodesk.png"
        },
        {
          id: 10,
          name: "Autodesk Eagle",
          logo: "img/auv/sponsors/autodesk_eagle.png"
        },
        {
          id: 11,
          name: "STM32 Cube",
          logo: "img/auv/sponsors/stm32.png"
        }
      ],

      mainTopics: [
        {
          id: 1,
          picture: "img/auv/news/recorded_video.jpg",
          date: "1/6/2021",
          title: "We went on AIR. 📽",
          category: "Fun 🎉",
          description:
            "The team finished recording the submission video in our office."
        },
        {
          id: 2,
          picture: "img/auv/news/simulation.GIF",
          date: "4/5/2021",
          title: "Our first VIRTUAL points. 🎉",
          category: "Software 👨‍💻",
          description:
            "The team integrated SWIFT to our Simulator and AUTONOMOUSLY CROSSED THE GATE."
        },
        {
          id: 3,
          picture: "img/auv/news/prop_building.png",
          date: "15/3/2021",
          title: "Time to test 💪",
          category: "Mechanical ⚙️",
          description:
            "The team manufactured the gate to start the real testing."
        },
        {
          id: 4,
          picture: "img/auv/news/object_detection.jpg",
          date: "24/2/2021",
          title: "98% a Gate! 🎉",
          category: "Software 👨‍💻",
          description:
            "Our Object detection model managed to classify the gate successfully with a 98% percision."
        },
        {
          id: 5,
          picture: "img/auv/news/enclosure_test.png",
          date: "14/1/2021",
          title: "Safe to dive 👍",
          category: "Mechanical ⚙️",
          description: "We managed to test our enclosures up to 7-bar pressure."
        },
        {
          id: 6,
          picture: "img/auv/news/enclosures.png",
          date: "12/1/2021",
          title: "Enclosures Manufacturing ⚙️",
          category: "Mechanical ⚙️",
          description:
            "We manufactured the main AUV Enclosures and prepared them for sealing testing."
        },
        {
          id: 7,
          picture: "img/auv/news/first_pcb.png",
          date: "5/1/2021",
          title: "First PCB ⚡",
          category: "Electrical ⚡",
          description:
            "The first PCB in our AUV was manufactured successfully. (Propulsion PCB)"
        },
        {
          id: 8,
          picture: "img/auv/news/zed2_config.jpeg",
          date: "2/1/2021",
          title: "ZED2 Configuration 📷",
          category: "Software 👨‍💻",
          description:
            "The team managed to configure & run the ZED-2 and extract the 3d constructed map."
        },
        {
          id: 9,
          picture: "img/auv/news/components.jpeg",
          date: "12/11/2020",
          title: "Components Delivery",
          category: "Software 👨‍💻",
          description:
            "The team received a shipment containing the most expensive components in our AUV; dvl & zed2"
        },
        {
          id: 10,
          picture: "img/auv/news/awarness.jpeg",
          date: "11/04/2021",
          title:
            "Raising awareness of underwater robotics to smaller generations",
          category: "Out Reach 📣",
          description:
            "To utilize the experience in the underwater world, Not only in the commercial field but also in the academic field. Vortex held an ROV training program, at the Arab Academy for Science, Technology, and Maritime Transport in Egypt, in preparation for the Seaperch 2021 competition, and So vortex took first place."
        },
        {
          id: 11,
          picture: "img/auv/news/sea_perch.jpeg",
          date: "9/4/2021",
          title: "First place in Seaperch competition",
          category: "Out Reach 📣",
          description:
            "Vortex held a training program for ROV to compete in the Seaperch competition 2021 in Egypt at Arab Academy for Science, Technology & Maritime Transport and Vortex  won the first place."
        }
      ]
    };
  },
  destroyed() {
    window.removeEventListener("scroll", this.moveAUV);
  },
  mounted() {
    window.addEventListener("scroll", this.moveAUV);
    document.documentElement.style.scrollBehavior = "smooth";

    var tabs = document.getElementById("right_nav").querySelectorAll("a");
    for (var i = 0; i < tabs.length; i++) {
      tabs[i].style.color = "white";
    }
    document
      .getElementById("vortexNameImage")
      .setAttribute("src", "img/logos/vortex_name2.png");
    window.scrollTo(0, 10);
    this.fadeInElements = Array.from(
      document.getElementsByClassName("fade-in")
    );
    document.addEventListener("scroll", this.handleScroll);
    this.handleScroll();

    this.filterSelection("All");
    document.getElementById("nav-collapse").style.backgroundColor =
      "rgb(0,0,0,0)";
    document.getElementById("n121").style.backgroundColor =
      "rgb(242, 242, 242, 0)";
    document.getElementById("n122").style.backgroundColor = "rgb(0,0,0,0)";
    document.getElementById("n123").style.backgroundColor = "rgb(0,0,0,0)";
    document.getElementById("n121").style.color = "rgb(0,0,0) !important";
    var tabs = document.getElementById("right_nav").querySelectorAll("a");
    for (var i = 0; i < tabs.length; i++) {
      tabs[i].style.color = "white";
    }
    document
      .getElementById("vortexNameImage")
      .setAttribute("src", "img/logos/vortex_name2.png");
  },
  methods: {
    translateAUV1(that, value) {
      value = value + 3;
      if (value >= screen.width * 2) return;
      document.getElementById("moving-auv").style.webkitTransform =
        "translate( " + value + "px, 0px)";
      setTimeout(() => this.translateAUV1(that, value), 3);
    },
    translateAUV2(that, value) {
      value = value + 3;
      if (value >= screen.width * 2) return;
      document.getElementById("moving-auv-2").style.webkitTransform =
        "translate( -" + value + "px, 0px)";
      setTimeout(() => this.translateAUV2(that, value), 1);
    },
    moveAUV() {
      if (window.scrollY > 1300) {
        document.getElementById("appendix-button").style.display = "block";
      } else {
        document.getElementById("appendix-button").style.display = "none";
      }
      var position1 = document
        .getElementById("moving-auv")
        .getBoundingClientRect();

      if (
        this.firstTime &&
        position1.top >= 0 &&
        position1.bottom <= window.innerHeight
      ) {
        this.translateAUV1(this, 0);
        this.firstTime = false;
      }

      var position2 = document
        .getElementById("moving-auv-2")
        .getBoundingClientRect();

      if (
        this.firstTime2 &&
        position2.top >= 0 &&
        position2.bottom <= window.innerHeight
      ) {
        this.translateAUV2(this, 0);
        this.firstTime2 = false;
      }
    },
    onShown() {
      this.$refs.cancel.focus();
    },
    onHidden() {
      this.$refs.show.focus();
    },
    handleScroll(evt) {
      for (var i = 0; i < this.fadeInElements.length; i++) {
        var elem = this.fadeInElements[i];
        if (this.isElemVisible(elem)) {
          elem.style.opacity = "1";
          elem.style.transform = "scale(1)";
        } else {
          elem.style.opacity = "0";
        }
      }
    },
    isElemVisible(el) {
      var rect = el.getBoundingClientRect();
      var elemTop = rect.top + 150; // 200 = buffer
      var elemBottom = rect.bottom;
      return elemTop < window.innerHeight && elemBottom >= 0;
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    youClicked() {
      window.scrollBy(0, 900);
    },
    filterSelection(c) {
      var x, i;
      x = document.getElementsByClassName("newsColumn");
      if (c == "All") c = "";
      this.noNews = true;
      for (i = 0; i < x.length; i++) {
        this.w3RemoveClass(x[i], "show");
        if (x[i].className.indexOf(c) > -1) {
          this.w3AddClass(x[i], "show");
          this.noNews = false;
        }
      }
    },
    w3AddClass(element, name) {
      var i, arr1, arr2;
      arr1 = element.className.split(" ");
      arr2 = name.split(" ");
      for (i = 0; i < arr2.length; i++) {
        if (arr1.indexOf(arr2[i]) == -1) {
          element.className += " " + arr2[i];
        }
      }
    },
    w3RemoveClass(element, name) {
      var i, arr1, arr2;
      arr1 = element.className.split(" ");
      arr2 = name.split(" ");
      for (i = 0; i < arr2.length; i++) {
        while (arr1.indexOf(arr2[i]) > -1) {
          arr1.splice(arr1.indexOf(arr2[i]), 1);
        }
      }
      element.className = arr1.join(" ");
    }
  },
  name: "RobosubAUV"
};
</script>

<style lang="scss">
$size: 30px;
$accent: #f2f2f2;

html {
  scroll-behavior: smooth !important;
}

body {
  scroll-behavior: smooth !important;
}

.carousel_container {
  width: 90%;
  display: inline-block;
  /*padding-top: 80px;*/
  padding-bottom: 30px;
  opacity: 1;
  -webkit-animation: fadein 2s; /* Safari, Chrome and Opera > 12.1 */
  -moz-animation: fadein 2s; /* Firefox < 16 */
  -ms-animation: fadein 2s; /* Internet Explorer */
  -o-animation: fadein 2s; /* Opera < 12.1 */
  animation: fadein 2s;
}
.inlnblk {
  display: inline-block !important;
}
.info_img {
  border-radius: 50% !important;
}

.apply-now-btn {
  margin-left: 20px;
  width: 50%;
}

.main_carousel {
  width: 90%;
  display: inline-block;
  overflow: hidden;
  border-radius: 15px;
}
.lower-section,
.upper-section {
  display: flex;
  /*justify-content: center;*/
  align-items: center;
}
.upper-section {
  min-height: 50;
  width: 100%;
  background: #ffffff;
}

.info-img {
  border-radius: 15px !important;
}

.containerr {
  position: relative;
  text-align: center;
  color: white;
  width: 90%;
  margin: auto;
  overflow: hidden;
  // padding-top: 56.25%;
}

.responsive-iframe {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
}

.mid-screen-text {
  z-index: 4;
}

.centered {
  text-align: justify;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.quality-container-col {
  margin: 30px;
  min-width: 300px;
  max-width: 400px !important;
  background-color: white;
  border-radius: 20px;
  box-shadow: 0 0px 10px 5px rgba(0, 0, 0, 0.3);
  padding: 0px !important;
}

.quality-container-col .carousel-inner {
  border-top-right-radius: 20px;
  border-top-left-radius: 20px;
  box-shadow: 0px 7px 5px 0px rgba(0, 0, 0, 0.3);
  cursor: pointer;
}

.what-we-do {
  text-align: center;
  font-size: 40px;
  color: #fff;
  font-weight: 900;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  line-height: 40px;
  margin-top: 20px;
}

.who-we-are {
  text-align: center;
  font-size: 30px;
  color: #fff;
  font-weight: 600;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  line-height: 30px;
}

.timeline {
  position: relative;

  &::before {
    content: "";
    background: #f2f2f2;
    width: 5px;
    height: 95%;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }
}

.timeline-item {
  width: 100%;
  margin-bottom: 70px;

  &:nth-child(even) {
    .timeline-content {
      float: right;
      padding: 40px 30px 10px 30px;

      .date {
        right: auto;
        left: 0;
      }

      &::after {
        content: "";
        position: absolute;
        border-style: solid;
        width: 0;
        height: 0;
        top: 30px;
        left: -15px;
        border-width: 10px 15px 10px 0;
        border-color: transparent #f5f5f5 transparent transparent;
      }
    }
  }

  &::after {
    content: "";
    display: block;
    clear: both;
  }
}

.inline-horizontal-scroll {
  width: 100%;
  margin: auto;
  overflow-y: visible;
  margin-top: 100px;
}

.timeline-content {
  position: relative;
  width: 45%;
  padding: 10px 30px;
  border-radius: 4px;
  background: #f5f5f5;
  box-shadow: 0 20px 15px -15px rgba(0, 0, 0, 0.3);

  &::after {
    content: "";
    position: absolute;
    border-style: solid;
    width: 0;
    height: 0;
    top: 30px;
    right: -15px;
    border-width: 10px 0 10px 15px;
    border-color: transparent transparent transparent #f5f5f5;
  }
}
.lower-section {
  min-height: 50vh;
  width: 100%;
  background: #f2f2f2;
}
.section-divider {
  position: relative;
  padding-top: 20px;
}
.section-divider:before {
  font-family: "codepen";
  content: " ";
  width: 6.5rem;
  height: 6.5rem;
  background: #f2f2f2;
  border-radius: 100%;
  position: absolute;
  top: -3.25rem;
  left: calc(50% - 3.25rem);
  line-height: 6rem;
  text-indent: 1.75rem;
  font-size: 3rem;
}
.section-divider1 {
  position: relative;
  padding-bottom: 40px;
}
.section-divider1:before {
  font-family: "codepen";
  content: " ";
  width: 6.5rem;
  height: 6.5rem;
  background: #ffffff;
  border-radius: 100%;
  position: absolute;
  top: -3.25rem;
  left: calc(50% - 3.25rem);
  line-height: 6rem;
  text-indent: 1.75rem;
  font-size: 3rem;
}
#divider {
  position: relative;
  top: 0%;
  height: 10%;
  background: $accent;
  &:after {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    bottom: -$size;
    height: $size;
    background-image: linear-gradient(45deg, transparent 75%, $accent 75%),
      linear-gradient(-45deg, transparent 75%, $accent 75%);
    background-position: center;
    background-size: $size $size;
  }
}
.gear {
}
.slogan_logo {
  width: 50px;
  height: 50px;
}
.grey_strip {
  background: #f2f2f2;
  width: 100%;
  height: 70px;
}
.left_slogan {
  text-align: left;
  transition: 0.7s ease-in-out;
  transform: translate(-140%, 0);
}

.position-absolute {
  width: 100% !important;
  padding: 30px;
}

.right_slogan {
  text-align: right;
  transition: 0.7s ease-in-out;
  transform: translate(140%, 0);
}
.carousel-caption {
  bottom: 35% !important;
}
.goDown {
  overflow: hidden;
  width: 100%;
  max-height: 0px;
  margin-top: 70px;
  -webkit-transition: max-height 1.5s ease-out, box-shadow 0.6s linear;
  -moz-transition: max-height 1.5s ease-out, box-shadow 0.6s linear;
  -o-transition: max-height 1.5s ease-out, box-shadow 0.6s linear;
  -ms-transition: max-height 1.5s ease-out, box-shadow 0.6s linear;
  transition: max-height 1.5s ease-out, box-shadow 0.6s linear;
}
.grey {
  background: #f2f2f2;
}
.info-card {
  text-align: left;
  margin-left: 9%;
  margin-bottom: 5%;
  margin-top: 5%;
  max-width: 80%;
}
.card {
  border: none !important;
}
.flying_gear {
  z-index: 9999;
  background: url("../../public/img/logos/logo48g.png");
  width: 48px;
  height: 48px;
  position: fixed;
  right: 90px;
  top: 200px;
}
.fly_right_up {
  right: 10px;
  top: 200px;
}
.fly_right_down {
  right: 10px;
  top: 480px;
}
.fly_left_up {
  left: 10px;
  top: 250px;
}
.fly_left_down {
  left: 25px;
  top: 550px;
}
.carousel_padding {
  -webkit-animation: fadein 1s; /* Safari, Chrome and Opera > 12.1 */
  -moz-animation: fadein 1s; /* Firefox < 16 */
  -ms-animation: fadein 1s; /* Internet Explorer */
  -o-animation: fadein 1s; /* Opera < 12.1 */
  animation: fadein 1s;
  -webkit-transition: width 2.4s; /* For Safari 3.1 to 6.0 */
  transition: width 2.4s;
}
.white {
  width: 100%;
  height: 200px;
  background: #ffffff;
  overflow: hidden;
  z-index: 3;
  position: relative;
}
.bkg {
  /*background:#FFFFFF url(../../public/img/background2.png) center no-repeat;*/
  background: #ffffff;
  width: 100%;
  height: 182px;
}

/* Center website */
.main {
  max-width: 100%;
  margin: auto;
  background-color: #f1f1f1;
  padding: 20px;
}

.mini-nav-container {
  margin: auto;
  padding: 30px;
  background-color: #fff;
  border-radius: 10px;
  margin-top: -150px;
  margin-bottom: 100px;
}

.auv-accordion {
  width: 90%;
  margin: auto;
}

.auv-accordion .btn {
  background-color: #00264a;
  color: white;
  font-weight: bold;
  transition: 0.3s all;
}

.auv-accordion .btn:hover {
  background-color: #084480 !important;
  transform: scale(1.1);
}

.auv-accordion .btn:focus {
  background-color: #00264a;
  border-color: #00264a;
  box-shadow: none;
}

.newsImageContainer {
  vertical-align: middle;
  min-width: 200px;
  max-width: 400px;
  // height: 350px;
  margin: auto;
  overflow: hidden;
}

.newsImage {
  max-width: 100%;
  max-height: 350px;
  border-radius: 10px;
  display: block;
}

h1 {
  font-size: 50px;
  word-break: break-all;
}

.row {
  margin: 8px -16px;
}

/* Add padding BETWEEN each column (if you want) */
.row,
.row > .newsColumn {
  padding: 8px;
}

/* Create three equal columns that floats next to each other */
.newsColumn {
  float: left;
  width: 33.33%;
  display: none; /* Hide columns by default */
}

.newsHeader {
  text-align: left;
  font-size: 200%;
  color: #00264a;
  font-weight: bolder;
}

/* Clear floats after rows */
.row:after {
  content: "";
  display: table;
  clear: both;
}

/* Content */
.newsContent {
  background-color: white;
  border-radius: 10px;
  padding: 10px;
}

/* The "show" class is added to the filtered elements */
.show {
  display: block;
}

/* Style the buttons */
.myBtnContainer .btn {
  border: none;
  outline: none;
  padding: 12px 16px;
  margin-bottom: 8px;
  margin-right: 10px;
  background-color: white;
  font-weight: bold;
  color: #00264a;
  cursor: pointer;
}

.myBtnContainer {
  margin-top: -50px;
}

/* Add a grey background color on mouse-over */
.myBtnContainer .btn:hover {
  background-color: #ddd;
  color: #00264a;
}

.date {
  color: darkgray;
  font-size: 100%;
}

/* Add a dark background color to the active button */
.btn.activeNews {
  background-color: #666;
  color: white;
}

.sloganBtn {
  display: inline-block;
  height: 50px;
  width: 50%;
  text-align: center;
  color: white;
  background: #f2f2f2;
  line-height: 50px;
  text-decoration: none;
  padding-bottom: 15%;
  background-clip: content-box;
  overflow: hidden;
}
.sloganBtn:after {
  content: "";
  position: absolute;
  top: 100px;
  left: -25%;
  background-color: inherit;
  padding-bottom: 75%;
  width: 150%;
  z-index: 0;

  -webkit-transform-origin: 0 0;
  -ms-transform-origin: 0 0;
  transform-origin: 0 0;

  -webkit-transform: rotate(-30deg) skewX(30deg);
  -ms-transform: rotate(-30deg) skewX(30deg);
  transform: rotate(-30deg) skewX(30deg);
}

.video-container-auv {
  background-color: #464549;
}

:root {
  --triangleWidthNeg: -1400px;
  --triangleheightNeg: -200px;
  --triangleHeight: 200px;
  --triangleWidth: 1400px;
}

.overlay {
  position: absolute;
  width: 100%;
}

.sponsor-logo {
  min-width: 250px;
  max-width: 250px;
  padding: 25px 25px 25px 25px;
  display: inline-block;
  overflow: hidden;
  vertical-align: middle;
}

.sponsor-logo-img {
  width: 100%;
  line-height: 250px;
}

.hexagon {
  overflow: hidden;
  visibility: hidden;
  -webkit-transform: rotate(120deg);
  -moz-transform: rotate(120deg);
  -ms-transform: rotate(120deg);
  -o-transform: rotate(120deg);
  transform: rotate(120deg);
  cursor: pointer;
}

.image-container-overlay {
  position: absolute;
  top: -5px;
  left: -5px;
  right: -5px;
  bottom: -5px;
  background-color: rgba(0, 188, 212, 0);
  transition: background-color 0.5s;
  width: 188px;
  height: 90px;
  border-top-left-radius: 110px;
  border-top-right-radius: 110px;
  border: 5px solid #00264a;
  border-bottom: 0;
}

.hexagon-in1 {
  overflow: hidden;
  width: 100%;
  height: 100%;
  -webkit-transform: rotate(-60deg);
  -moz-transform: rotate(-60deg);
  -ms-transform: rotate(-60deg);
  -o-transform: rotate(-60deg);
  transform: rotate(-60deg);
}
.hexagon-in2 {
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: contain;
  visibility: visible;
  -webkit-transform: rotate(-60deg);
  -moz-transform: rotate(-60deg);
  -ms-transform: rotate(-60deg);
  -o-transform: rotate(-60deg);
  transform: rotate(-60deg);
}

.mini-nav-button {
  background-color: #00264a !important;
  color: white;
  font-weight: bold !important;
  margin: 5px;
  width: 130px;
  transition: 0.2s all ease-in-out !important;
}

.mini-nav-button:hover {
  transform: scale(1.1);
}

.hexagon-image-crew {
  background-image: url("../../public/img/services/crew_v.jpg");
}
.hexagon-image-academic {
  background-image: url("../../public/img/services/academic.jpg");
}
.hexagon-image-first-rov {
  background-image: url("../../public/img/services/first_rov.png");
}
.hexagon-image-store {
  background-image: url("../../public/img/services/crew_v.jpg");
}

.hexagon2 {
  width: 120%;
  height: 650px;

  margin: auto;
}

.breaker {
  width: 100px;
  border-top: 5px solid #00264a;
  margin: auto;
  margin-top: -5px;
  margin-bottom: 20px;
}
.sponsor-logo .tooltip-inner {
  background-color: #f2f2f2;
  color: black;
}
.bs-tooltip-top .arrow::before {
  border-top-color: #f2f2f2 !important;
}
.what-we-do-icon {
  margin: auto;
  max-height: 100px;
}

.eliptical-gray {
  background-color: #f2f2f2;
  -moz-border-radius: 150% / 35%;
  -webkit-border-radius: 150% / 35%;
  border-radius: 150% / 35%;
  padding-top: 60px;
  padding-bottom: 60px;
  // -webkit-box-shadow: inset 0px 0px 8px 0px rgba(0, 0, 0, 0.58);
  // -moz-box-shadow: inset 0px 0px 8px 0px rgba(0, 0, 0, 0.58);
  // box-shadow: inset 0px 0px 8px 0px rgba(0, 0, 0, 0.58);
}

.what-we-do-cards {
  min-width: 300px;
  max-width: 300px;
  height: 320px;
  padding: 25px 25px 25px 25px;
  display: inline-block;
  overflow: hidden;
  background-color: #fff;
  border-radius: 10px;
  margin: 10px;
  box-shadow: 0 0px 10px 5px rgba(0, 0, 0, 0.3);
}

.auv-heads-cards {
  min-width: 200px;
  height: 300px;
  padding: 5px;
  display: inline-block;
  overflow: visible;
  background-color: inherit;
  border-radius: 10px;
  margin: 10px;
  margin-top: 100px;
}

.auv-members-cards {
  width: 200px;
  height: 300px;
  padding: 5px;
  display: inline-block;
  overflow: visible;
  background-color: inherit;
  border-radius: 10px;
  margin: 10px;
  transform: scale(0.8);
}

.auv-heads-cards .card {
  border-top: 5px solid #00264a !important;
}

.auv-members-cards .card {
  border-top: 5px solid #00264a !important;
}

.what-we-do-cards .header {
  margin: auto;
  font-weight: bolder;
  padding-top: 20px;
  padding-bottom: 10px;
  color: #00264a;
  font-size: 140%;
}

.what-we-do-cards .description {
  color: #7a7575;
  font-size: 100%;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  position: relative;
  // left: -18px;
  // width: 118%;
}

.moving-auv-img {
  width: 30%;
  left: -70%;
  position: relative;
}

.moving-auv-img-2 {
  width: 30%;
  right: -70%;
  position: relative;
}

.main-topics-container {
  margin: auto;
  width: 70%;
  margin-top: 50px;
}

.shift-up {
  margin-top: -150px;
}

.back-text {
  position: relative;
  opacity: 0.05;
  top: 45px;
  z-index: 0;
  font-size: 70px;
  font-weight: 700;
}

.auv-specs .badge-info {
  background-color: #fff;
}

.down-arrow {
  transform: rotate(90deg);
  -webkit-transform: rotate(90deg);
  -moz-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  -o-transform: rotate(90deg);
}

.up-arrow {
  transform: rotate(180deg);
}

@-webkit-keyframes bounce {
  0% {
    transform: rotate(90deg) scale(1, 1) translate(0px, 0px);
  }

  30% {
    transform: rotate(90deg) scale(0.8, 1) translate(5px, 0px);
  }

  75% {
    transform: rotate(90deg) scale(1.1, 1) translate(-15px, 0px);
  }

  100% {
    transform: rotate(90deg) scale(1, 1) translate(0px, 0px);
  }
}

.bounce {
  text-align: center;
  position: relative;
  top: 20px;
  margin: 0 auto;
  width: 50px;
  -webkit-animation: bounce 1.5s infinite;
  color: rgba(255, 255, 255, 0.4) !important;
  font-size: 200%;
  font-weight: bold;
  z-index: 6;
  cursor: pointer;
  margin-top: -15px;
}

.bounce a {
  color: white;
}
.bounce a:hover {
  color: rgb(219, 209, 209);
}

.contact-us-home-button {
  margin: auto;
  margin: 40px;
  z-index: 7;
}

.justify_in_row {
  text-align: center;
}
select option[value="Other"] {
  color: grey;
}
select {
  margin-bottom: 15px;
}
.tips {
  color: darkgrey;
  width: 50%;
  display: inline-block;
}
.entry {
  min-height: 350px;
  border: 1px solid;
}
#customBtn {
  display: inline-block;
  background: white;
  color: #444;
  width: 190px;
  border-radius: 5px;
  border: thin solid #888;
  box-shadow: 1px 1px 1px grey;
  white-space: nowrap;
}
#customBtn:hover {
  cursor: pointer;
}
span.label {
  font-family: serif;
  font-weight: normal;
}
span.icon {
  background: url("/identity/sign-in/g-normal.png") transparent 5px 50%
    no-repeat;
  display: inline-block;
  vertical-align: middle;
  width: 42px;
  height: 42px;
}
span.buttonText {
  display: inline-block;
  vertical-align: middle;
  padding-left: 42px;
  padding-right: 42px;
  font-size: 14px;
  font-weight: bold;
  /* Use the Roboto font that is loaded in the <head> */
  font-family: "Roboto", sans-serif;
}

#blog {
  margin-bottom: 3em;
}
.mapouter {
  padding: 30px 30px;
  display: inline-block;
  position: relative;
  height: 271px;
  width: 80%;
}
.gmap_canvas {
  left: 0%;
  background-image: url("../../public/img/map.png");
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  overflow: hidden;
  background-color: #c3ecb2 !important;
  height: 400px;
  padding: 65px 0px 0px 0px;
}
.gmap_canvas body {
  background-image: linear-gradient(
      45deg,
      rgba(194, 233, 221, 0.5) 1%,
      rgba(104, 119, 132, 0.5) 100%
    ),
    linear-gradient(-45deg, #494d71 0%, rgba(217, 230, 185, 0.5) 80%);
  margin: 0;
}

#buttons {
  padding: 2px 2px;
  width: 330px;
  overflow: hidden;
}
.button {
  background: #dce0e0;
  position: relative;
  display: inline-block;
  height: 50px;
  margin: 4px;
  overflow: hidden;
  width: 200px;
  border-radius: 3px;
  -o-border-radius: 3px;
  -ms-border-radius: 3px;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
}
.fb-page,
.fb-page span,
.fb-page span iframe[style] {
  width: 100% !important;
}
.icon {
  display: block;
  float: left;
  position: relative;
  z-index: 3;
  height: 100%;
  width: 38px;
  -moz-border-radius-topleft: 3px;
  -moz-border-radius-topright: 0px;
  -moz-border-radius-bottomright: 0px;
  -moz-border-radius-bottomleft: 3px;
  -webkit-border-radius: 3px 0px 0px 3px;
  border-radius: 3px 0px 0px 3px;
  text-align: center;
}
.icon i {
  color: #fff;
  line-height: 42px;
}

.auv-specs .list-group-item {
  border: none !important;
  transition: 0.4s all ease-in-out !important;
}

.list-group-item:hover {
  font-weight: bold;
  transform: scale(1.1);
  cursor: pointer;
}

.services-cards-container {
  display: inline-block;
  width: 100%;
  /* height: 400px;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap; */
}

.badge-info {
  color: #fff;
  background-color: rgba(0, 0, 0, 0);
  height: 70px;
}

.badge-primary {
  background-color: yellow;
  color: black;
  font-size: 100%;
}

.auv-specs .b-avatar {
  height: 100% !important;
}

#contact_us_auv .slide {
  z-index: 2;
  display: block;
  margin: 0;
  height: 100%;
  position: absolute;
  width: 163px;
  left: 38px;
  -moz-border-radius-topleft: 0px;
  -moz-border-radius-topright: 3px;
  -moz-border-radius-bottomright: 3px;
  -moz-border-radius-bottomleft: 0px;
  -webkit-border-radius: 0px 3px 3px 0px;
  border-radius: 0px 3px 3px 0px;
}
.slide p {
  border-left: 1px solid #fff;
  border-left: 1px solid rgba(255, 255, 255, 0.35);
  color: #fff;
  font-size: 18px;
  left: 0;
  margin: 0;
  position: absolute;
  text-align: center;
  top: 10px;
  width: 100%;
}
.button .slide {
  -webkit-transition: all 0.2s ease-in-out;
  -moz-transition: all 0.2s ease-in-out;
  -ms-transition: all 0.2s ease-in-out;
  -o-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
}
.facebook iframe {
  display: block;
  position: absolute;
  right: 23px;
  top: 10px;
  z-index: 1;
}
.twitter iframe {
  width: 90px !important;
  right: 5px;
  top: 10px;
  z-index: 1;
  display: block;
  position: absolute;
}
.google #___follow_0 {
  width: 70px !important;
  top: 10px;
  right: 45px;
  position: absolute;
  display: block;
  z-index: 1;
}
.youtube #___ytsubscribe_0 {
  top: 10px;
  right: 1px;
  position: absolute;
  display: block;
  z-index: 1;
}
.facebook:hover .slide {
  left: 220px !important;
}
.twitter:hover .slide {
  top: -40px !important;
}
.google:hover .slide {
  bottom: -50px !important;
}
.gmail:hover .slide {
  bottom: -50px !important;
}
.youtube:hover .slide {
  left: -210px !important;
}
.linkedin:hover .slide {
  left: -210px !important;
}
.facebook .icon,
.facebook .slide {
  background: #305c99;
}
.linkedin .icon,
.linkedin .slide {
  background: #006599;
}

.gmail .icon,
.gmail .slide {
  background: purple;
}

.twitter .icon,
.twitter .slide {
  background: #00cdff;
}
.google .icon,
.google .slide {
  background: #7ea91b;
}
.youtube .icon,
.youtube .slide {
  background: #b31217;
}

.contact-form {
  font-family: 16px;
  margin: 0 auto;
  padding: 15px 15px 15px;
  max-width: 700px;
  width: 100%;
}
.contact-form .separator {
  border-bottom: solid 1px #ccc;
  margin-bottom: 15px;
}
.contact-form .form {
  display: flex;
  flex-direction: column;
  font-size: 16px;
}
.contact-form_title {
  color: #333;
  text-align: left;
  font-size: 28px;
}
.contact-form input[type="email"],
.contact-form input[type="text"],
.contact-form input[type="phone"],
.contact-form textarea {
  border: solid 1px #e8e8e8;
  font-family: "Roboto", sans-serif;
  padding: 10px 7px;
  margin-bottom: 15px;
  outline: none;
}
.contact-form textarea {
  resize: none;
}
.contact-form .button {
  background: #367ee7;
  border: solid 1px #1663d7;
  color: white;
  cursor: pointer;
  padding: 10px 50px;
  text-align: center;
  text-transform: uppercase;
}
.contact-form .button:hover {
  background: #1963d7;
  border: solid 1px #1963d7;
}
.contact-form input[type="email"],
.contact-form input[type="text"],
.contact-form textarea,
.contact-form .button {
  font-size: 15px;
  border-radius: 3px;
}
#social_button_container {
  margin: 50px 0px 0px;
}
.be_full_width {
  width: 100%;
  left: 0;
}
.card-ceo {
  position: relative;
}
.card-cto {
  position: relative;
}
#cto_pic_up {
  visibility: hidden;
  display: none !important;
}
#cto_pic_down {
  visibility: visible;
  display: block;
}
.card-title {
  font-size: 1.5em;
}

.overlay-linkedin {
  opacity: 1;
  transition: 0.3s ease;
  backface-visibility: hidden;
}

.image-container {
  position: relative;
  max-width: 180px;
  border-radius: 50%;
  margin-top: 10px;
  margin-bottom: 10px;
  margin-left: auto;
  margin-right: auto;
}

.auv-heads-cards .card-body {
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 0px;
  padding-right: 0px;
  margin-top: -60px;
}

.back-to-top-btn {
  width: 50px;
  height: 50px;
  position: fixed;
  bottom: 100px;
  right: 20px;
  z-index: 99999;
  display: none;
}

.back-to-top-span {
  color: #00264a !important;
  font-weight: bolder;
  text-shadow: 0px 0px 20px #000;
  z-index: 99999;
}

.auv-members-cards .card-body {
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 0px;
  padding-right: 0px;
  margin-top: -60px;
}

.middle {
  cursor: pointer;
  transition: 0.5s ease;
  opacity: 0;
  position: absolute;
  top: 80%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  text-align: center;
}

.team-member-card {
  text-align: center;
  border: none;
  width: 250px;
  margin: auto;
  box-shadow: 0 0px 10px 5px rgba(0, 0, 0, 0.3);
}

.image-container:hover .middle {
  opacity: 1;
}

.fw-n {
  font-weight: normal !important;
}

.fc-p {
  color: #05264a;
  font-weight: bold;
}

.card-img-top {
  width: 180px;
  position: relative;
  margin: auto;
  display: inline-block;
  height: 180px;
  margin-top: -2px;
}

.card-img-top .rounded-circle {
  border-radius: 49%;
}

.fade-in {
  // margin-bottom: 50px;
  opacity: 0;
  transition: 0.8s all ease-in-out;
  transform: scale(0.8);
  box-sizing: border-box;
  padding: 20px;
  margin-top: -50px;
}

.v-drax-specs-content {
  align-self: center;
}

.table-caption {
  color: #9a8c2c;
  caption-side: bottom;
  margin: auto;
  padding-bottom: 10px;
}
.vdrax-img-left {
  width: 150%;
  margin-left: -40%;
}

.vdrax-img-right {
  width: 150%;
}

.table.b-table.b-table-stacked > tbody > tr > [data-label]::before {
  text-align: left;
}

@media screen and (max-width: 762px) {
  #cto_pic_up {
    visibility: visible;
    display: block !important;
  }
  #cto_pic_down {
    visibility: hidden;
    display: none !important;
  }

  .justi {
    display: inline-block;
    text-align: center;
  }
  #breakeer {
    display: none !important;
  }
}
@media screen and (max-width: 760px) {
  .auv-specs-left .row-cols-2 > * {
    max-width: 100%;
    margin: auto;
  }
  .auv-specs-right .order-2 {
    order: 1 !important;
  }

  .auv-specs-right .row-cols-2 > * {
    max-width: 100%;
    margin: auto;
  }

  .card-ceo {
    display: inline-block;
    text-align: center;
    width: 100%;
    left: 0%;
  }
  .card-cto {
    display: inline-block;
    text-align: center;
    width: 100%;
    left: 0%;
  }
  #breakeer {
    display: none !important;
  }
}
@media screen and (max-width: 500px) {
  .inline-horizontal-scroll {
    white-space: nowrap;
    overflow-x: auto;
    margin-top: 0px;
    padding-top: 40px;
    padding-right: 50px;
  }
  .tips {
    width: 90%;
  }
  .card-ceo {
    text-align: center;
    width: 100%;
    left: 0%;
  }
  .card-cto {
    text-align: center;
    width: 100%;
    left: 0%;
  }
  .containerdiv {
    display: inline-block;
    text-align: center;
  }
}
@media screen and (max-width: 455px) {
  .mailto {
    font-size: 12px;
  }
}
@media screen and (max-width: 683px) {
  .container_sb {
    padding: 0px 50px 0px 50px;
  }
}
@media screen and (max-width: 500px) {
  .this_row {
    display: inline-block !important;
  }
  .this_row {
    position: relative;
    left: -30%;
  }
  .tips {
    width: 90%;
  }
  .container_sb {
    padding: 0px 0px 0px 0px;
  }
  .container_sb {
    position: relative;
    left: 30%;
  }
  /*#social_button_container {
        margin: 50px 100px 0px;
    }*/
}

@media screen and (max-width: 1150px) {
  .newsColumn {
    width: 50%;
  }
}

@media screen and (max-width: 900px) {
  .mid-screen-text {
    top: 50%;
  }

  .what-we-do {
    font-size: 21px;
    line-height: 21px;
    margin-top: 5px;
  }

  .who-we-are {
    font-size: 17px;
  }
}

@media screen and (max-width: 700px) {
  .myBtnContainer .col {
    flex-basis: unset !important;
  }

  .back-text {
    top: 40px;
    font-size: 50px;
  }
  .newsColumn {
    width: 100%;
  }
  .myBtnContainer .btn {
    width: 100% !important;
    margin-bottom: 10px;
  }
  .shift-up {
    margin-top: 0px;
  }
  .eliptical-gray {
    -moz-border-radius: 170% / 10%;
    -webkit-border-radius: 170% / 10%;
    border-radius: 170% / 10%;
    padding: 0px;
    padding-top: 70px;
    padding-bottom: 70px;
  }
}

@media screen and (max-width: 575px) {
  .accordion-content .position-relative {
    overflow-y: scroll;
  }

  .accordion-content .position-absolute {
    height: 600px;
  }
  .vdrax-img-left {
    width: 100%;
    margin-left: 0%;
  }
  .vdrax-img-right {
    width: 100%;
    margin-right: 0%;
  }
}

@media screen and (max-width: 500px) {
  .large-hexa-container .col {
    flex-basis: inherit;
  }
  .hexagon2 {
    width: 80%;
    height: 400px;
    margin: auto !important;
  }
  .newsColumn {
    width: 100%;
  }
  .myBtnContainer .btn {
    width: 100% !important;
    margin-bottom: 10px;
  }

  .what-we-do-cards {
    margin: auto !important;
    margin-bottom: 20px !important;
  }
  .contact-us-home-button {
    font-size: 13px !important;
  }
}

@keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Firefox < 16 */
@-moz-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Safari, Chrome and Opera > 12.1 */
@-webkit-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Internet Explorer */
@-ms-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>
